import { render, staticRenderFns } from "./Doses.vue?vue&type=template&id=f98e0226&"
import script from "./Doses.vue?vue&type=script&lang=js&"
export * from "./Doses.vue?vue&type=script&lang=js&"
import style0 from "./Doses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
